import {
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import TimeTable from './TimeTable';

export default function MasterViewModal({
  open,
  scheduleId,
  scheduleName,
  handleClose,
}) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.25 }}>
        <Typography variant="h3">{scheduleName || scheduleId}</Typography>
        <IconButton edge="end" onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <Divider />

      <DialogContent>
        <TimeTable scheduleId={scheduleId} isEditable={false} stage='view' masterView={true} />
      </DialogContent>
    </Dialog>
  );
}
